import React from "react";
import { RouteComponentProps, RouterProps, Redirect } from "react-router";
import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import {
    SetHeader,
    ShowBackNavigationWithRoute,
    showBackButton,
    SetShowBackNavigation,
} from "../../ducks/common";
import { connect } from "react-redux";
import { Grid, Typography } from "material-ui";
import CreateLoginForm, {
    CreateLoginFormData,
} from "./components/CreateLoginForm";
import { createLogin } from "../../ducks/user";
import logger from "../../util/logger";

interface ICreateLoginPageProps
    extends RouteComponentProps<{ verificationHash: string }> {}
interface ICreateLoginPageReduxProps {}
interface ICreateLoginPageDispatchProps {
    CreateLogin: (
        username: string | null | undefined,
        password: string | null | undefined,
        verifyPassword: string | null | undefined,
        verificationHash: string
    ) => Promise<string>;
    setHeaderValue: (header: string) => void;
    setBackButton: (route: string) => void;
    showBackButton: (show: boolean) => void;
}

interface ICreateLoginPageState {}

type CreateLoginPageProps = ICreateLoginPageProps &
    ICreateLoginPageReduxProps &
    ICreateLoginPageDispatchProps &
    RouterProps;

class CreateLoginPage extends React.Component<
    CreateLoginPageProps,
    ICreateLoginPageState
> {
    constructor(props: CreateLoginPageProps) {
        super(props);
    }
    componentDidMount() {
        this.props.setHeaderValue("");
        this.props.setBackButton("/profile");
    }
    componentWillUnmount() {
        this.props.setHeaderValue("");
        this.props.showBackButton(false);
    }
    createLogin = async (data: CreateLoginFormData) => {
        this.props
            .CreateLogin(
                data.username,
                data.password,
                data.verifyPassword,
                this.props.match.params.verificationHash
            )
            .then(() => this.props.history.push("/profile"))
            .catch((err) => logger.error(err));
    };
    render() {
        if (!this.props.match.params.verificationHash) {
            return <Redirect to="/eidentify/4" />;
        }
        return (
            <div className="LoginPage_Container container-with-logo">
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                    }}
                >
                    <Grid container spacing={0} justify="center">
                        <Grid item xs={12} sm={10} md={6}>
                            <h1
                                className={"loginHeader"}
                                style={{ color: "#646363" }}
                            >
                                Luo tunnus
                            </h1>
                            <CreateLoginForm
                                form="createloginform"
                                onSubmit={this.createLogin}
                            />
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ReduxState): ICreateLoginPageReduxProps => {
    return {
        // ...mapStateToProps
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): ICreateLoginPageDispatchProps => {
    return {
        // ...mapDispatchToProps
        CreateLogin: async (
            username: string,
            password: string,
            verifyPassword: string,
            verificationHash: string
        ) => {
            return await dispatch(
                createLogin(
                    username,
                    password,
                    verifyPassword,
                    verificationHash
                )
            );
        },
        setHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
        setBackButton: (route) => {
            return dispatch(ShowBackNavigationWithRoute(route));
        },
        showBackButton: (show) => {
            return dispatch(SetShowBackNavigation(false));
        },
    };
};

export default connect<
    ICreateLoginPageReduxProps,
    ICreateLoginPageDispatchProps,
    ICreateLoginPageProps
>(
    mapStateToProps,
    mapDispatchToProps
)(CreateLoginPage);



// WEBPACK FOOTER //
// ./src/views/profile/CreateLoginPage.tsx